import { LoyaltyEstimateResponseDto } from 'actions/loyalty/LoyaltyDtos';
import { emptyLoyaltyEstimate, LoyaltyEstimate } from 'types/Loyalty';

const toFiniteNumber = (value: unknown): number =>
    typeof value === 'number' && Number.isFinite(value) ? value : 0;

export const convertLoyaltyEstimate = (
    dto?: Partial<LoyaltyEstimateResponseDto> | null
): LoyaltyEstimate => {
    if (!dto || typeof dto !== 'object') {
        return emptyLoyaltyEstimate;
    }

    return {
        enabled: dto.enabled === true,
        pointsToEarn: toFiniteNumber(dto.pointsToEarn),
        estimatedWalletValue: toFiniteNumber(dto.estimatedWalletValue)
    };
};
